import React, { useEffect, useRef, useState } from 'react';
import {
    Box, Button, Typography, Container, Stack, TextField,
    FormControlLabel, Checkbox // Import Checkbox and FormControlLabel
} from '@mui/material';
import { MapContainer, TileLayer, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet-draw/dist/leaflet.draw.css';
import 'leaflet-draw';

import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import dbUserFromUser from '../auth/DataApi';
import { useNotification } from '../notification/NotificationProvider';

// New component to update map center
const MapUpdater = ({ position }) => {
    const map = useMap();

    useEffect(() => {
        if (position) {
            map.setView(position, map.getZoom());
        }
    }, [position, map]);

    return null;
};


const DrawControl = ({ onDraw }) => {
    const map = useMap();
    const drawnItemsRef = useRef(new L.FeatureGroup());

    useEffect(() => {
        const drawnItems = drawnItemsRef.current;
        map.addLayer(drawnItems);

        const drawControl = new L.Control.Draw({
            draw: {
                polygon: true,
                polyline: false,
                rectangle: false,
                circle: false,
                marker: false,
                circlemarker: false,
            },
            edit: { featureGroup: drawnItems }
        });

        map.addControl(drawControl);

        map.on(L.Draw.Event.CREATED, (e) => {
            drawnItems.clearLayers();
            const { layer } = e;
            drawnItems.addLayer(layer);
            const latlngs = layer.getLatLngs();
            onDraw(latlngs);
        });

        return () => {
            map.removeControl(drawControl);
        };
    }, [map, onDraw]);

    return null;
};

const PropertyFormScreen = () => {
    const { currentUser, dbUser } = useAuth();
    const [userPosition, setUserPosition] = useState([40.4168, -3.7038]);
    const [zone, setZone] = useState(null);
    const [propertyName, setPropertyName] = useState('');
    const [propertyDetails, setPropertyDetails] = useState(''); // New state for details
    const [isPublic, setIsPublic] = useState(true); // New state for public/private access
    const navigate = useNavigate();
    const {triggerNotification} = useNotification();

    useEffect(() => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                ({ coords }) => setUserPosition([coords.latitude, coords.longitude]),
                (err) => {
                    console.warn("Error getting geolocation:", err);
                }
            );
        } else {
            console.log("Geolocation is not supported by this browser.");
        }
    }, []);


    const handleSubmit = async () => {
        if (!zone || !propertyName) return;

        const newProperty = {
            name: propertyName,
            coordinates: zone,
            details: propertyDetails, // Add details to the new property object
            isPublic: isPublic, // Add isPublic to the new property object
        };

        const misbolosObj = {
            properties: {}
        }
        misbolosObj.properties[newProperty.name] = newProperty
        const bro = {
            ...currentUser,
            misbolos: misbolosObj
        }

        // console.log('UPdate Obj',)
        // console.log('Bro?', bro.misbolos.properties)
        // await dbUserFromUser(bro);
        
        const response = await dbUser.addProperty(newProperty)
        console.log('response?', response)
        const not = {
            message: response.message,
            sound: true,
            show: true,
            type: 'tiny-top',
            cat: 'received-request-from-group',
        }
        await dbUser.update();
        // triggerNotification(not)
        //TODO: Pass to state the reload action to make the admin panel (UPDATES but not RELOADS the content)
        navigate('/misbolos/admin', {state: {requiresUpdate: true}});
    };

    return (
        <Box sx={{ minHeight: '100vh', background: '#f0f4f8', py: 4 }}>
            <Container maxWidth="md">
                <Stack spacing={4}>
                    <Typography variant="h4" textAlign="center">Nueva propiedad</Typography>

                    <TextField
                        label="Nombre de la propiedad"
                        value={propertyName}
                        onChange={(e) => setPropertyName(e.target.value)}
                        fullWidth
                    />

                    <TextField
                        label="Detalles de la propiedad (opcional)" // New TextField for details
                        value={propertyDetails}
                        onChange={(e) => setPropertyDetails(e.target.value)}
                        fullWidth
                        multiline
                        rows={3}
                    />

                    <FormControlLabel // New FormControlLabel for the checkbox
                        control={
                            <Checkbox
                                checked={isPublic}
                                onChange={(e) => setIsPublic(e.target.checked)}
                                name="isPublic"
                                color="primary"
                            />
                        }
                        label="Acceso público"
                    />

                    <Box sx={{ height: 400, borderRadius: 2, overflow: 'hidden', padding: 6}}>
                        <MapContainer center={userPosition} zoom={13} style={{ height: '100%' }}>
                            <TileLayer
                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                attribution='&copy; OpenStreetMap contributors'
                            />
                            {/* Add the MapUpdater component here */}
                            <MapUpdater position={userPosition} />
                            <DrawControl onDraw={setZone} />
                        </MapContainer>
                    </Box>

                    <Button
                        variant="contained"
                        onClick={handleSubmit}
                        disabled={!zone || !propertyName}
                    >
                        Confirmar
                    </Button>
                </Stack>
            </Container>
        </Box>
    );
};

export default PropertyFormScreen;